import React, { Component } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import qs from "qs";
import { Alert, message, Modal, Button } from "antd";
import MobileDetect from "mobile-detect";
import draftToHtml from "draftjs-to-html";

import BookingStep1 from "./BookingStep1";
import BookingStep2 from "./BookingStep2";
import BookingStep3 from "./BookingStep3";
import BookingStep4 from "./BookingStep4";
import { withRouter } from "react-router-dom";
import { withRedux } from "../../hoc";
import { fetchApi, splitStringNum } from "../../utils";
import { Steps, LayoutPage, KbankButton } from "../../components";

const md = new MobileDetect(window.navigator.userAgent);
message.config({ top: md.mobile() ? "10%" : "30%", maxCount: 1 });

const cornersSeatsData = {
  A: [
    [1, 10],
    [11, 20],
    [21, 30],
  ],
  B: [
    [1, 13],
    [14, 24],
    [25, 37],
  ],
  C: [
    [1, 13],
    [14, 25],
    [26, 38],
  ],
  D: [
    [1, 13],
    [14, 26],
    [27, 39],
  ],
  E: [
    [1, 13],
    [14, 27],
    [28, 40],
  ],
  F: [
    [1, 13],
    [14, 28],
    [29, 41],
  ],
  G: [
    [1, 12],
    [13, 28],
    [29, 40],
  ],
  H: [
    [1, 12],
    [13, 29],
    [30, 41],
  ],
  I: [
    [1, 8],
    [9, 26],
    [27, 34],
  ],
  J: [
    [1, 8],
    [9, 27],
    [28, 35],
  ],
  K: [
    [1, 7],
    [8, 27],
    [28, 34],
  ],
  L: [
    [1, 7],
    [8, 28],
    [29, 35],
  ],
  M: [
    [1, 6],
    [7, 22],
    [23, 28],
  ],
  N: [[1, 15]],
  VA: [
    [1, 5],
    [6, 10],
    [11, 15],
  ],
  VB: [
    [1, 7],
    [8, 13],
    [14, 18],
    [19, 23],
  ],
  P: [
    [1, 13],
    [14, 27],
    [28, 40],
  ],
  Q: [
    [1, 13],
    [14, 28],
    [29, 41],
  ],
  R: [
    [1, 12],
    [13, 27],
    [28, 39],
  ],
  S: [
    [1, 12],
    [13, 28],
    [29, 40],
  ],
  T: [
    [1, 12],
    [13, 28],
    [29, 40],
  ],
  U: [
    [1, 13],
    [14, 30],
    [31, 43],
  ],
  V: [
    [1, 13],
    [14, 30],
    [31, 43],
  ],
  W: [
    [1, 14],
    [15, 32],
    [33, 46],
  ],
  X: [
    [1, 11],
    [12, 28],
    [29, 40],
  ],
};

const dateFotmat = "YYYY/MM/DD";
const today = dayjs().format(dateFotmat);

const steps = [
  { id: 1, name: "Date & Showtime" },
  { id: 2, name: "Select your seats" },
  { id: 3, name: "Payment" },
  { id: 4, name: "Confirmation" },
];

const mapStateToProps = ({ language, t, auth }) => {
  return {
    language,
    t,
    auth,
    isLogin: _.get(auth, "isLogin"),
    balance: _.toNumber(_.get(auth, "data.balance")),
  };
};

@withRouter
@withRedux(mapStateToProps)
export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0, // 0
      bookingInfo: [],
      comfirmBookingData: null,
      seatInformation: [],
      emptySeat: [],
      selectedSeat: [],
      checked: false,
      showtimes: [],
      selectedDate: today,
      selectedShowtimeId: null,
      selectedShowtime: null,
      loadingShowtimes: false,
      loadedShowtimes: false,
      pleaseSelectSeatIds: [],
      isRemove: false,
    };
  }

  componentDidMount() {
    const { auth } = this.props;
    if (_.get(auth, "isLoginChecked") === true) {
      this.init();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { auth } = this.props;
    if (
      _.get(auth, "isLoginChecked") !== _.get(prevProps, "auth.isLoginChecked")
    ) {
      if (_.get(auth, "isLoginChecked") === true) {
        this.init();
      }
    }

    const search = this.props.location.search;
    const propsPath = qs.parse(search, { ignoreQueryPrefix: true });
    const propsDate = _.get(propsPath, "date");
    const propsShowtimeId = _.get(propsPath, "showtimeId");

    const prevPropsSearch = prevProps.location.search;
    const prevPropsPath = qs.parse(prevPropsSearch, {
      ignoreQueryPrefix: true,
    });
    const prevPropsDate = _.get(prevPropsPath, "date");
    const prevPropsShowtimeId = _.get(prevPropsPath, "showtimeId");

    if (propsDate && propsShowtimeId) {
      if (
        propsDate !== prevPropsDate ||
        propsShowtimeId !== prevPropsShowtimeId
      ) {
        this.init();
      }
    }
    if (prevState.currentStep !== this.state.currentStep) {
      window.scrollTo(0, 0);
    }
  }

  init = async () => {
    this.setState({ checked: false });

    const { search } = this.props.location;
    const path = qs.parse(search, { ignoreQueryPrefix: true });

    const status = _.get(path, "status");
    const key = _.get(path, "key");
    const date = _.get(path, "date");
    const showtimeId = _.get(path, "showtimeId");

    if (date && showtimeId) {
      const hasShowTime = await this.fetchRoundTime(date, showtimeId);
      if (hasShowTime) {
        this.setState({
          currentStep: 1,
          selectedDate: date,
          selectedShowtimeId: _.toNumber(showtimeId),
        });
      }
    } else {
      if (status) {
        if (status === "success" && key) {
          const bookingInfo = await this.fetchBookingInfo(key);
          if (_.get(bookingInfo, "status") === "success") {
            this.setState({
              bookingInfo: _.get(bookingInfo, "data"),
              currentStep: 3,
            });
          }
        } else if (status === "fail") {
          this.setState({
            currentStep: 0,
          });
        }
      }
      this.fetchShowTimes(this.state.selectedDate);
    }
    this.setState({ checked: true });
  };

  fetchShowTimes = async (date, showtimeId = null) => {
    const { auth } = this.props;

    this.setState({
      selectedDate: date,
      loadingShowtimes: true,
      loadedShowtimes: false,
    });

    const isLogin = _.get(auth, "isLogin");
    const token = _.get(auth, "token");

    let headers = {};
    let url = "booking/showtime";
    let dataPost = {
      ShowDate: date,
    };

    if (isLogin) {
      url = "booking/agent/showtime";
      headers = {
        Authorization: `Bearer ${token}`,
      };
    }
    const mapField = (item) => {
      return {
        ...item,
        dinings: _.map(_.get(item, "dinings"), (i) => {
          return {
            ...i,
            description: _.reduce(
              _.get(i, "description"),
              (result, value, language) => {
                return {
                  ...result,
                  [language]: draftToHtml(value),
                };
              },
              {}
            ),
          };
        }),
        description: _.reduce(
          _.get(item, "description"),
          (result, value, language) => {
            return {
              ...result,
              [language]: draftToHtml(value),
            };
          },
          {}
        ),
      };
    };

    const showtimes = await fetchApi(
      url,
      "POST",
      JSON.stringify(dataPost),
      headers
    )
      .then((res) => _.get(res, "data"))
      .then((items) => _.map(items, mapField));

    const selectedShowtimeId = showtimeId
      ? showtimeId
      : this.defaultShowtimes(showtimes);
    const selectedShowtime =
      _.find(showtimes, ["showTimeID", _.toNumber(selectedShowtimeId)]) || null;
    this.setState({
      loadingShowtimes: false,
      loadedShowtimes: true,
      showtimes,
      selectedShowtimeId: selectedShowtime ? selectedShowtimeId : null,
      selectedShowtime,
      // selectedShowfoods: showFoods,
    });
    return showtimes;
  };

  fetchRoundTime = async (date, showtimeId) => {
    const showtimes = await this.fetchShowTimes(date, showtimeId);
    if (_.isEmpty(showtimes)) return false;
    return this.fetchSeatInformationApi(date, showtimeId);
  };

  fetchBookingInfo = async (key) => {
    return fetchApi(`booking/info?key=${encodeURIComponent(key)}`, "POST");
  };

  fetchSeatInformationApi = async (selectedDate, showtimeId) => {
    const { auth } = this.props;
    const isLogin = _.get(auth, "isLogin");
    const token = _.get(auth, "token");

    let headers = {};
    let url = "booking/allot";
    let dataPost = {
      ShowDate: dayjs(selectedDate).format(dateFotmat),
      ShowTimeID: showtimeId,
    };

    if (isLogin) {
      url = "booking/agent/allot";
      headers = {
        Authorization: `Bearer ${token}`,
      };
    }

    const items = await fetchApi(url, "POST", JSON.stringify(dataPost), headers)
      .then((res) => _.get(res, "data"))
      .then((items) =>
        _.map(items, (item) => {
          return {
            ...item,
            seatNo: _.replace(_.get(item, "seatNo"), " ", ""),
            seatName: _.replace(_.get(item, "seatName"), " ", ""),
          };
        })
      );
    if (_.isEmpty(items)) return false;
    this.setState(
      {
        seatInformation: items,
      },
      () => this.getEmptySeat()
    );
    return true;
  };

  getEmptySeat = () => {
    const { seatInformation } = this.state;
    const seatInformationFilter = _.filter(seatInformation, (v) => {
      return _.get(v, "seatStatus") !== 1;
    });
    const emptySeatNew = _.map(seatInformationFilter, (v) => v.seatNo);
    this.setState({
      emptySeat: emptySeatNew,
    });
  };

  handleClickNextStep1 = (selectedDate, selectedShowtimeId) => {
    const url = `/booking?date=${selectedDate}&showtimeId=${selectedShowtimeId}`;
    this.props.history.push(url);
  };

  handleClickNextStep2 = (data) => {
    const { currentStep } = this.state;
    const { search } = this.props.location;
    const path = qs.parse(search, { ignoreQueryPrefix: true });
    const order_id = _.get(path, "order_id");
    this.setState({
      currentStep: currentStep + 1,
      comfirmBookingData: {
        ...data,
        orderId: order_id
      },
      // comfirmBookingData: data,
    });
  };

  groupSeatByRow = (seats) => {
    const data = _.reduce(
      seats,
      (result, seatId) => {
        const [str, num] = splitStringNum(seatId);
        return {
          ...result,
          [str]: [...(result[str] || []), _.toInteger(num)],
        };
      },
      {}
    );
    return data;
  };

  showErrorBySeat = (seatId) => {
    const { t } = this.props;
    const errorSeatElement = document.querySelector(`#error_seat_${seatId}`);
    if (errorSeatElement) return;

    const seatElement = document.querySelector(`#seat_${seatId}`);
    if (!seatElement) return;

    const mapsitElement = document.querySelector("#mapsit");
    if (!mapsitElement) return;

    const seatBbox = seatElement.getBBox();
    const seatX = seatBbox.x;
    const seatY = seatBbox.y;
    const seatWidth = seatBbox.width;
    const seatHeight = seatBbox.height;

    const boxWidth = 150;
    const boxHeight = 30;

    const createRect = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "rect"
    );
    createRect.setAttributeNS(null, "width", `${boxWidth}px`);
    createRect.setAttributeNS(null, "height", `${boxHeight}px`);
    createRect.setAttributeNS(null, "x", 0);
    createRect.setAttributeNS(null, "y", 0);
    createRect.setAttributeNS(null, "rx", "4px");
    createRect.setAttributeNS(null, "ry", "4px");
    createRect.setAttributeNS(null, "fill", "#000000");
    createRect.setAttributeNS(null, "opacity", "0.9");

    const createTriangleDownSvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    createTriangleDownSvg.setAttributeNS(null, "viewBox", "0 0 400 400");
    createTriangleDownSvg.setAttributeNS(null, "x", "0");
    createTriangleDownSvg.setAttributeNS(null, "y", "50%");
    const createTriangleDown = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    createTriangleDown.setAttributeNS(
      null,
      "d",
      "M 100 100 L 300 100 L 200 300 z"
    );
    createTriangleDown.setAttributeNS(null, "fill", "#000000");
    createTriangleDown.setAttributeNS(null, "opacity", "0.9");
    createTriangleDownSvg.appendChild(createTriangleDown);

    const createText = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "text"
    );
    createText.setAttributeNS(null, "x", "50%");
    createText.setAttributeNS(null, "y", "50%");
    createText.setAttributeNS(null, "fill", "#ffffff");
    createText.setAttributeNS(null, "font-family", "Roboto");
    createText.setAttributeNS(null, "dominant-baseline", "middle");
    createText.setAttributeNS(null, "text-anchor", "middle");
    createText.appendChild(document.createTextNode(t("Don't leave space")));

    const addEventClickErrorSeat = () => {
      setTimeout(() => {
        const _self = this;
        const errorSeatElement = document.querySelector(
          `#error_seat_${seatId}`
        );
        errorSeatElement.addEventListener("click", function(event) {
          _self.onClickSeat(seatId);
        });
        // if (md.mobile()) {
        //   errorSeatElement.addEventListener("touchstart", function(event) {
        //     _self.onClickSeat(seatId);
        //   });
        // } else {
        // }
      }, 10);
    };

    const createSvg = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    );
    createSvg.setAttributeNS(null, "width", `${boxWidth}px`);
    createSvg.setAttributeNS(null, "height", `${boxHeight}px`);
    createSvg.setAttributeNS(null, "x", seatX - boxWidth / 2 + seatWidth / 2);
    createSvg.setAttributeNS(null, "y", seatY - boxHeight - seatHeight / 2);
    createSvg.setAttributeNS(null, "id", `error_seat_${seatId}`);
    createSvg.setAttributeNS(null, "cursor", "pointer");
    createSvg.setAttributeNS(null, "onclick", addEventClickErrorSeat());

    createSvg.appendChild(createRect);
    createSvg.appendChild(createTriangleDownSvg);
    createSvg.appendChild(createText);

    mapsitElement.appendChild(createSvg);

    message.error(t("Please don't leave space"));
    this.setState({
      pleaseSelectSeatIds: _.uniq([...this.state.pleaseSelectSeatIds, seatId]),
    });
  };

  hideErrorBySeat = (seatId) => {
    const errorSeatElement = document.querySelector(`#error_seat_${seatId}`);
    if (errorSeatElement) {
      errorSeatElement.remove();
      if (_.includes(this.state.pleaseSelectSeatIds, seatId)) {
        this.setState({
          pleaseSelectSeatIds: _.filter(
            this.state.pleaseSelectSeatIds,
            (pleaseSelectSeatId) => {
              return pleaseSelectSeatId !== seatId;
            }
          ),
        });
      }
    }
  };

  getSelectedSeatTotalPrice = () => {
    const { selectedSeat, seatInformation } = this.state;
    const { balance } = this.props;

    const result = _.map(selectedSeat, (seat) => {
      let seatPrice = _.find(seatInformation, ["seatNo", seat]);
      seatPrice = _.toNumber(_.get(seatPrice, "price"));
      return seatPrice;
    });
    const selectedSeatTotalPrice = _.sum(result);

    let showErrorAgent = false;
    if (balance < selectedSeatTotalPrice) {
      showErrorAgent = true;
    }
    this.setState({
      selectedSeatTotalPrice: _.sum(result),
      showErrorAgent,
    });
  };

  onClickSeat = (seatId) => {
    message.destroy();
    this.hideErrorBySeat(seatId);

    let [str, num] = splitStringNum(seatId);
    num = _.toInteger(num);

    const cornersSeats = _.get(cornersSeatsData, str);
    const cornerSeats = _.find(cornersSeats, (cornerSeats) => {
      return num >= cornerSeats[0] && num <= cornerSeats[1];
    });

    let isRemove = false;
    const hasSeat = _.includes(this.state.selectedSeat, seatId);
    if (hasSeat) {
      isRemove = true;
    }
    const selectedSeat = hasSeat
      ? _.remove(this.state.selectedSeat, (value) => value !== seatId)
      : [...this.state.selectedSeat, seatId];

    this.setState(
      {
        selectedSeat,
        isRemove,
      },
      () => {
        const groupsSeats = this.groupSeatByRow([
          ...this.state.emptySeat,
          ...this.state.selectedSeat,
        ]);
        const groupsEmptySeats = this.groupSeatByRow(this.state.emptySeat);
        const groupSeats = _.sortBy(
          _.filter(_.get(groupsSeats, str), (id) => {
            return id >= cornerSeats[0] && id <= cornerSeats[1];
          })
        );
        const groupEmptySeats = _.sortBy(
          _.filter(_.get(groupsEmptySeats, str), (id) => {
            return id >= cornerSeats[0] && id <= cornerSeats[1];
          })
        );
        // find seat gap
        const findSeatGap = [];
        for (let index = cornerSeats[0]; index <= cornerSeats[1]; index++) {
          if (!_.includes(groupSeats, index)) {
            if (index === cornerSeats[0] && _.includes(groupSeats, index + 1)) {
              if (!_.includes(groupEmptySeats, index + 1)) {
                findSeatGap.push(index);
              }
            } else if (
              index === cornerSeats[1] &&
              _.includes(groupSeats, index - 1)
            ) {
              if (!_.includes(groupEmptySeats, index - 1)) {
                findSeatGap.push(index);
              }
            } else if (
              _.includes(groupSeats, index - 1) &&
              _.includes(groupSeats, index + 1)
            ) {
              findSeatGap.push(index);
            }
          }
        }
        // handle error by seat
        for (let index = cornerSeats[0]; index <= cornerSeats[1]; index++) {
          if (_.includes(findSeatGap, index)) {
            this.showErrorBySeat(`${str}${index}`);
          } else {
            this.hideErrorBySeat(`${str}${index}`);
          }
        }

        // pre-paid
        if (this.props.balance > 0) {
          this.getSelectedSeatTotalPrice();
        }
      }
    );
  };
  clearErrorMessage = () => {
    const { search } = this.props.location;
    const path = qs.parse(search, { ignoreQueryPrefix: true });
    const status = _.get(path, "status");
    const bookingErrorMessage = _.get(path, "message");
    if (status === "fail" && bookingErrorMessage) {
      this.props.history.push(this.props.location.pathname);
    }
  };
  handleClickDate = async (value) => {
    const date = dayjs(value).format(dateFotmat);
    this.fetchShowTimes(date);
    this.clearErrorMessage();
  };
  handleClickShowTime = (selectedShowtimeId) => {
    this.setState({
      selectedShowtimeId,
    });
    this.clearErrorMessage();
  };
  defaultShowtimes = (datas) => {
    const { selectedDate } = this.state;
    let showtimes = _.filter(datas, (showtime) => showtime.available > 0);
    const currentTime = dayjs();
    let diffTime = [];
    _.map(showtimes, (item) => {
      const stringTime = `${selectedDate} ${dayjs(
        _.get(item, "showTime")
      ).format("H:mm")}`;
      const time = dayjs(stringTime);
      const diff = time.diff(currentTime, "second");
      diffTime.push(diff);
    });
    const arrDiffTime = _.map(diffTime, (item) => {
      if (item < 0) {
        return null;
      } else {
        return item;
      }
    });
    const closeTime = _.min(arrDiffTime);
    const indexOfCloseTime = _.indexOf(arrDiffTime, closeTime);

    const currentShowtime = _.find(showtimes, (item, index) => {
      const stringTime = `${selectedDate} ${dayjs(
        _.get(item, "showTime")
      ).format("H:mm")}`;
      const time = dayjs(stringTime);
      const isBefore = dayjs(currentTime).isBefore(time);
      return indexOfCloseTime === index && isBefore;
    });
    return _.get(currentShowtime, "showTimeID");
  };
  getBookingStep = () => {
    const { search } = this.props.location;
    const path = qs.parse(search, { ignoreQueryPrefix: true });
    const key = _.get(path, "key");

    const {
      currentStep,
      selectedShowtime,
      comfirmBookingData,
      bookingInfo,
      selectedSeat,
      emptySeat,
      seatInformation,
      selectedDate,
      selectedShowtimeId,
      // selectedShowfoods,
      showtimes,
      loadingShowtimes,
      loadedShowtimes,
      pleaseSelectSeatIds,
      selectedSeatTotalPrice,
    } = this.state;

    const sortSelectedSeat = _.orderBy(selectedSeat, (item) => {
      const [str, num] = splitStringNum(item);
      return [str, num];
    });

    return (
      <div>
        <div style={{ display: currentStep === 0 ? "block" : "none" }}>
          <BookingStep1
            onClickNext={this.handleClickNextStep1}
            onClickDate={this.handleClickDate}
            onClickShowTime={this.handleClickShowTime}
            selectedDate={selectedDate}
            selectedShowtimeId={selectedShowtimeId}
            showtimes={showtimes}
            loadingShowtimes={loadingShowtimes}
            loadedShowtimes={loadedShowtimes}
          />
        </div>
        <div style={{ display: currentStep === 1 ? "block" : "none" }}>
          <BookingStep2
            foodAndDrinkList={_.get(showtimes, "foodAndDrinkList", [])}
            canBooking={_.isEmpty(pleaseSelectSeatIds)}
            selectedDate={selectedDate}
            selectedShowtimeId={selectedShowtimeId}
            selectedShowtime={selectedShowtime}
            // selectedShowfoods={selectedShowfoods}
            onClickPrev={(selectedDate, selectedShowtimeId) => {
              this.setState({
                currentStep: currentStep - 1,
                selectedSeat: [],
                selectedDate,
                selectedShowtimeId: _.toNumber(selectedShowtimeId),
              });
              this.props.history.push({
                pathname: "/booking",
              });
            }}
            onClickNext={this.handleClickNextStep2}
            onClickSeat={this.onClickSeat}
            selectedSeat={sortSelectedSeat}
            emptySeat={emptySeat}
            seatInformation={seatInformation}
            selectedSeatTotalPrice={selectedSeatTotalPrice}
            isRemove={(value) => this.setState({ isRemove: value })}
          />
        </div>
        <div style={{ display: currentStep === 2 ? "block" : "none" }}>
          <BookingStep3
            selectedShowtime={selectedShowtime}
            selectedDate={selectedDate}
            comfirmBookingData={comfirmBookingData}
            onClickPrev={() => this.setState({ currentStep: currentStep - 1 })}
          />
        </div>
        <div style={{ display: currentStep === 3 ? "block" : "none" }}>
          <BookingStep4 successKey={key} bookingInfo={bookingInfo} />
        </div>
      </div>
    );
  };

  render() {
    const { currentStep, checked, showErrorAgent, isRemove } = this.state;
    const { t } = this.props;
    const currentStepName = t(_.get(steps, `${currentStep}.name`));

    const { search } = this.props.location;
    const path = qs.parse(search, { ignoreQueryPrefix: true });

    const status = _.get(path, "status");
    const bookingErrorMessage = _.get(path, "message");
    const payment = _.get(path, "payment");
    const amount = _.get(path, "amount");
    const order_id = _.get(path, "order_id");

    let errorMessage = null;
    if (status === "fail" && bookingErrorMessage) {
      console.log("bookingErrorMessage", { path, bookingErrorMessage });
      errorMessage = decodeURIComponent(bookingErrorMessage);
    }

    errorMessage = t(errorMessage, "payment");

    console.log('BookingPayment', {payment, amount, order_id})
    return (
      <div className="booking-page">
        <LayoutPage
          pageName="BOX OFFICE"
          image={`${process.env.PUBLIC_URL}/assets/images/boxoffice-banner.jpg`}
        />
        <div style={{ display: !checked ? "block" : "none" }}>
          <div className="loading">{t("Loading")}...</div>
        </div>
        <div style={{ display: checked ? "block" : "none" }}>
          <div className="container">
            <div className="steps-block">
              <Steps currentSteps={currentStep} allSteps={steps} />
            </div>
            <div className="step-name">
              <h2>
                Step {currentStep + 1}
                <br /> {currentStepName}
              </h2>
            </div>
            {errorMessage && (
              <Alert
                message={errorMessage.split("\n").map((line) => (
                  <div>{line}</div>
                ))}
                type="error"
                showIcon
              />
            )}
            <div>{this.getBookingStep()}</div>
          </div>
        </div>
        {payment && amount && order_id && (
          <KbankButton
            action={`${process.env.REACT_APP_SERVICE}/${process.env.REACT_APP_API}/payment/kbank/${payment}/website/callback`}
            amount={amount}
            paymentMethods={payment}
            // paymentMethods="qr"
            orderId={order_id}
            submit
          />
        )}
        <Modal
          className="error-agent-modal"
          width={600}
          centered
          footer={null}
          visible={showErrorAgent && !isRemove}
          onCancel={() => this.setState({ showErrorAgent: false })}
        >
          <div className="error-agent-block">
            <p>
              {t(
                "Unable to process your Ticket payment transaction due to the amount exceeds your credit limit. Please contact Tiffany’s Counter Service."
              )}
            </p>
            <Button
              type="primary"
              onClick={() => this.setState({ showErrorAgent: false })}
            >
              Close
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Booking/index.js